<template>
  <div
    :tabindex="tabindex"
    :id="id"
    :class="customClass"
    @scroll="onScroll"
    ref="container"
    autofocus

  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'VInfiniteScroll',
  data() {
    return {
      scrollBottomDebounceTimer: null,
    };
  },
  props: {
    loading: { type: Boolean, required: true },
    offset: { type: Number, default: 100 },
    tabindex: { type: [String, Number], default: null },
    id: { type: String, default: null },
    autofocus: { type: Boolean, default: false },
    custom: { type: String, default: '' }
  },
  computed: {
    customClass() {
      return this.custom || '';
    }
  },
  methods: {
    onScroll(e) {
      if (this.loading) return;

      if (this.scrollBottomDebounceTimer) {
        clearTimeout(this.scrollBottomDebounceTimer);
      }

      this.scrollBottomDebounceTimer = setTimeout(() => {
        const container = e.target;
        const scrollTop = container.scrollTop;
        const clientHeight = container.clientHeight;
        const scrollHeight = container.scrollHeight;
        const offset = this.offset || 20; // Use offset prop if set or default

        // Detect scroll at bottom but only load next page if near bottom threshold
        if (scrollTop + clientHeight >= scrollHeight - offset) {
          this.$emit('bottom');
        }
        // Detect scroll at top for loading previous page
        else if (scrollTop <= offset) {
          this.$emit('top');
        }
      }, 50); // debounce delay to avoid multiple rapid firings 

      // const el = e.target;
      // const scrollTop = el.scrollTop;
      // const scrollHeight = el.scrollHeight;
      // const clientHeight = el.clientHeight;

      // if (scrollHeight - (scrollTop + clientHeight) <= this.offset) {
      //   this.$emit('bottom');
      // }
      // if (scrollTop <= this.offset) {
      //   this.$emit('top');
      // }
    },

    checkPosition() {
      const el = this.$refs.container;
      if (!el) return;

      const scrollTop = el.scrollTop;
      const scrollHeight = el.scrollHeight;
      const clientHeight = el.clientHeight;

      if (scrollHeight - (scrollTop + clientHeight) <= this.offset) {
        this.$emit('bottom');
      }
      if (scrollTop <= this.offset) {
        this.$emit('top');
      }
    }
  },
  mounted() {
    // if (this.autofocus) {
    //   this.$refs.container.focus();
    // }
    this.$nextTick(() => this.checkPosition());
  },
  updated() {
    this.checkPosition();
  }
};
</script>
